import { IconButton, TextField, Tooltip, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { invokePostService, setInnerScreenRender } from "../../../../store/global/actions";
import { useDispatch } from "react-redux";
import { Close as CloseIcon } from "@material-ui/icons";
import { isValidSimpleIdentifier } from "../../../../utils/commonUtils";

export default function EditableTitle({ title, endPoint, entityId, dataKey, variant = 'h6', titleStyle = {}, id, callBack }) {
    const dispatch = useDispatch();
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        setValue(title);
    }, [title])

    const defaultTitleStyle = {
        flexGrow: 1,
        fontFamily: "Roboto, Helvetica",
        fontSize: "16px",
        fontWeight: "bold",
        color: "#2c3b4a",
        marginLeft: "9px",
        cursor: "text",
        padding: "4px 8px",
        borderRadius: "6px",
        minWidth: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "200px",
    }

    const handleBlur = () => {
        if (!value.trim()) {
            setError("This field cannot be empty");
            return;
        }
        if (isValidSimpleIdentifier(value) === false) {
            setError("This field can only contain letters, numbers, and underscores")
            return;
        }
        setError("");
        setIsEditing(false);
        if (value.trim() !== title) {
            onSave(value.trim());
        }
    };

    const onSave = (name) => {
        setValue(name);
        const payload = {};
        if (dataKey) {
            payload[dataKey] = { name };
        } else {
            payload.name = name;
        }
        dispatch(invokePostService(endPoint, payload, [entityId])).then(response => {
            if (response.status == true) {
                dispatch(setInnerScreenRender());
                if (callBack && typeof callBack === "function") callBack(name);
            } else {
                setIsEditing(true);
                if (response.errors) {
                    setError("This value already exists");
                }
            }
        });
    }


    const handleCancel = () => {
        setValue(title);
        setError("");
        setIsEditing(false);
    };

    return (
        <>
            {isEditing ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <TextField
                        id={`${id}_input_field`}
                        autoFocus
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        onBlur={handleBlur}
                        onKeyDown={(e) => e.key === "Enter" && handleBlur()}
                        error={!!error}
                        helperText={error}
                    />
                    <IconButton id={"close_rename"} onMouseDown={handleCancel} size="small">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
            ) : (
                <Tooltip
                    title={value}
                    placement="bottom"
                    arrow
                    disableHoverListener={!value || value.length < 25} 
                >
                    <Typography
                        id={id}
                        onClick={() => setIsEditing(true)}
                        variant={variant}
                        style={{ ...defaultTitleStyle, ...titleStyle }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                    >
                        {value}
                    </Typography>
                </Tooltip>
            )}
        </>
    );
}
